// Single source of truth for Nacasky company details + per-role console theming.
// Real company details sourced from nacasky.com.
export const NACASKY = {
  name: "Nacasky Co. Ltd",
  descriptor: "Industry-standard IT solutions",
  tagline: "A GPRTU service · Developed & operated by Nacasky Co. Ltd",
  address: "P.O. Box AT 550, Achimota, Accra, Ghana",
  phone: "+233 20 814 0720",
  phoneHref: "tel:+233208140720",
  email: "info@nacasky.com",
  emailHref: "mailto:info@nacasky.com",
  web: "nacasky.com",
  webHref: "https://nacasky.com",
  hours: "Mon – Fri · 08:00 – 17:30",
};

// Each staff section gets a distinct accent while staying in one blue-led family.
export const ROLE_THEME = {
  admin: { accent: "#E11D48", soft: "bg-rose-50", text: "text-rose-600", ring: "ring-rose-200", label: "Super Admin Console" },
  station_master: { accent: "#EA580C", soft: "bg-orange-50", text: "text-orange-600", ring: "ring-orange-200", label: "Station Master Console" },
  teller: { accent: "#0052FF", soft: "bg-blue-50", text: "text-[#0052FF]", ring: "ring-blue-200", label: "Teller Counter" },
  cashier: { accent: "#059669", soft: "bg-emerald-50", text: "text-emerald-600", ring: "ring-emerald-200", label: "Cashier Office" },
  manager: { accent: "#4F46E5", soft: "bg-indigo-50", text: "text-indigo-600", ring: "ring-indigo-200", label: "Management Dashboard" },
  bus_owner: { accent: "#0284C7", soft: "bg-sky-50", text: "text-sky-600", ring: "ring-sky-200", label: "Bus Owner Portal" },
  customer: { accent: "#0052FF", soft: "bg-blue-50", text: "text-[#0052FF]", ring: "ring-blue-200", label: "Passenger" },
};
